module.exports = __webpack_public_path__ + "img/ptwist_athens.006be33e.jpg";